import { toast } from 'react-toastify';
import isEqual from 'react-fast-compare';
import { Button } from '@material-ui/core';
import { Container, Draggable } from 'react-smooth-dnd';
import { useTranslation } from 'react-i18next';
import { arrayMoveImmutable } from 'array-move';
import React, { useRef, useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import Swal from 'sweetalert2'
import Switch from 'react-switch';

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import Category from './Category';
import SubCategory from './SubCategory';
import ActiveColumn from './ActiveColumn';
import EditDiskHealthRules from './EditDiskHealthRules';

// import { updateColumns } from '../../../../Functions/user';
import { updateColumns, updateColumnsForModule } from '../../../../Functions/columns';
import { useAppContext } from '../../../../Context/App/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import {
  allReportingColumns, globalColumns, hardwareColumns, deviceWipeColumns, diskWipeColumns, testsHardwareColumns, allDiagnosticColumns, deploymentColumns,
  sbarColumns, imagingColumns, manualInputsColumns, tradeInColumns, welcomScreenColumns, hexadecimalViewerColumns,
  globalColumnsMobiles, hardwareColumnsMobiles, locksColumnsMobiles, operationsColumnsMobiles, manualInputsColumnsMobiles, otherColumnsMobiles, subHardwareColumnsMobiles,
  testsColumnsMobiles, disksWipeColumns, scriptsColumns, bootImageColumns, allManualInputsColumns, locksColumns
} from '../../../../Shared/reporting.js';

import { getAllAvailableColumns } from "./getAllAvailableColumns.js"

import { decodeHTMLEntities } from '../../../../Functions/utils';

import './Columns.css';
import { devicesTypeValues, toastTimerValue } from '../../../../Shared/utils';

import '../../../SweetAlert.css'

const icon = (
  <svg viewBox="0 0 10 10" height="100%" width="100%" fill="#fff">
    <circle r={3.5} cx={5} cy={5} />
  </svg>
);


export default function Columns({
  setShowColumnsMenu, welcomeScreenManualInputs, sdsQuestions, scriptHeaders, mobileOthersData,
  sdsExtraDiskHealthFlag, sdsExtraDiskPerfFlag
}) {
  const { t } = useTranslation();

  const [{ user, settings }] = useAppContext();
  const [{ reportingColumns, scenario, module, selected }, dispatch] = useReportingContext();
  const [{ reportingColumnsStatus }, eventDispatch] = useEventContext();

  const [loading, setLoading] = useState(false);
  const previousColumns = useRef(reportingColumns);
  const [nextColumns, setNextColumns] = useState(reportingColumns);

  const [renaming, setRenaming] = useState({ active: false, field: '', name: '', customHeaderName: false });
  const [editingDiskHealthPercentageComputingRules, setEditingDiskHealthPercentageComputingRules] = useState(false);

  const handleDragColumn = ({ removedIndex, addedIndex }) => {
    // console.log("46 - removedIndex=", removedIndex);
    // console.log("47 - addedIndex=", addedIndex);
    // console.log("60 - handleDragColumn=", removedIndex, addedIndex);

    const testsCommentsElement = nextColumns.find((col) => {
      return col.field === 'diag_common_$$_tests_comments';
    });

    const tmpColumns = nextColumns.filter(
      col => col.field !== 'diag_common_$$_tests_comments'
    )
    
    const newColumns = arrayMoveImmutable(tmpColumns, removedIndex, addedIndex);
    if (tmpColumns.length < nextColumns.length)
      newColumns.push(testsCommentsElement);

    setNextColumns(newColumns);

    // dispatch({ reportingColumns: newColumns });
    // eventDispatch({ reportingColumnsStatus: 'loaded' });

  };

  const handleResetColumns = () => {
    // eventDispatch({ reportingColumnsStatus: 'loaded' });

    setNextColumns(previousColumns.current);
    // dispatch({ reportingColumns: previousColumns.current });
    // console.log("69 - reportingColumns...");
  };

  const handleUpdateColumns = (e, columns, scenario, module, settings) => {
    e.preventDefault();
    setLoading(true);

    // console.log("48 - handleUpdateColumns=", e, columns, scenario);

    // columns.forEach(element => {
    //   if (element.headerName === "" || element.customHeaderName === false) {
    //     element.headerName = "";
    //     element.customHeaderName = false;
    //   }
    // });
    dispatch({ reportingColumns: nextColumns });

    if (settings.mode === undefined || settings.mode !== "modules") {

    updateColumns(columns, scenario && scenario.id, 'reporting').then(res => {
      if (!res.success) {
        setLoading(false);
          return toast(decodeHTMLEntities(t('settings.columns.error')), { type: 'error' });
      }

        toast(decodeHTMLEntities(t('settings.columns.success')), { type: 'success' });

        eventDispatch({ reportingColumnsStatus: 'loaded' });
        setLoading(false);
        setShowColumnsMenu(false);
      });
    }
    else if (settings.mode === "modules") {

      updateColumnsForModule(columns, module, 'reporting').then(res => {
        if (!res.success) {
          setLoading(false);
          return toast(decodeHTMLEntities(t('settings.columns.error')), { type: 'error' });

        }
        toast(decodeHTMLEntities(t('settings.columns.success')), { type: 'success' });

        eventDispatch({ reportingColumnsStatus: 'loaded' });
      setLoading(false);
        setShowColumnsMenu(false);
    });
    }

    // console.log("109 - reportingColumns=", reportingColumns);
    // console.log("110 - columns=", columns);
    // dispatch({ reportingColumns: columns });
  };

  // console.log("77 - sdsQuestions=", sdsQuestions);
  // console.log("94 - scriptHeaders=", scriptHeaders); //mobileOthersData
  // console.log("219 - nextColumns=", nextColumns);
  // console.log("214 - settings=", settings);
  // console.log("215 - user=", user);
  // console.log("216 - selected=", selected);

  let groupId = user.groupId ? user.groupId : selected.groups && selected.groups.length === 1 ? selected.groups[0].value : null;
  // console.log("219 - groupId=", groupId);


  // MAKE ALL AVAILABLE COLUMNS
  let allAvailableColId = getAllAvailableColumns(scenario, welcomeScreenManualInputs, sdsQuestions, scriptHeaders, mobileOthersData, sdsExtraDiskHealthFlag, sdsExtraDiskPerfFlag);
  // console.log("159 - allAvailableColId=", allAvailableColId);

  const isColumnChecked = (column) => nextColumns && nextColumns.map(col => col.field).includes(column);
  const setColumnHeader = (column) => {
    const [title, subtitle, extra, desc] = column.field.split('_$$_');

    // console.log("30 - column.field=", column.field);
    const isWelcomeScreenManualInput = column.field.length > 39 && (column.field.substring(0, 39) === "welcome_screen_$$_input_value_$$_input#");
    const isSdsQuestion = column.field.length > 45 && (column.field.substring(0, 45) === "questions_form_$$_question_value_$$_question#");
    const isScript = column.field.length > 33 && (column.field.substring(0, 33) === "script_$$_script_value_$$_script#");
    const isComments = column.field.length > 16 && (column.field.substring(0, 16) === "diag_comment_$$_");
    const isMobileOthersData = column.field.length > 17 && (column.field.substring(0, 17) === "other_mobiles_$$_");

    column.customHeaderName = false;
    column.disableReorder = true;

    if (isWelcomeScreenManualInput) {
      const strTmp = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)}`
      column.headerName = strTmp;
    }
    else if (isSdsQuestion) {
      const strTmp = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)}`
      column.headerName = strTmp;
    }
    else if (isScript) {
      column.headerName = `${t(`reporting.columns.${title}.sub_title`)}`;
    }
    else if (column.parentTitle) {
      column.headerName = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
    }
    else if (isComments) {
      column.headerName = `${t(`reporting.columns.settings.diagnostics`)} \u2013 ${t(`reporting.columns.${subtitle}.sub_title`)}`;
    }
    else if (isMobileOthersData) {
      if (!extra) {
        column.headerName = `${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
      }
      else {
        column.headerName = `${t(`reporting.columns.${title}.sub_title`)}`;
      }
    }
    else {
      column.headerName = `${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
    }

    if (extra) {
      if (isWelcomeScreenManualInput) {
        const found = welcomeScreenManualInputs && welcomeScreenManualInputs.find((element) => {
          const strTest = element.xtra_id + "_$$_" + element.xtra_desc;
          return strTest === column.field.substring(39);     // String VS numeric...
        });

        if (found) {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.input`) + ` #` + found.xtra_id + ' : ' + found.xtra_desc;
        }
        else {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.input`) + ` #` + column.field.substring(39);
        }
      }
      else if (isSdsQuestion) {
        const found = sdsQuestions && sdsQuestions.find((element) => {

          const strTest = element.xtra_id + "_$$_"+ element.xtra_desc;
          return strTest === column.field.substring(45);     // String VS numeric...
        });


        if (found) {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.sds_questions`) + ` #` + found.xtra_id + ' : ' + found.xtra_desc;
        }
        else {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.sds_questions`) + ` #` + column.field.substring(45);
        }
      }
      else if (isScript) {
        const found = scriptHeaders && scriptHeaders.find((element) => {
          return element === column.field.substring(33);     // String VS numeric...
        });

        if (found) {
          column.headerName = column.headerName + ` \u2013 ` + found;
        }
        else {
          column.headerName = column.headerName + ` \u2013 ` + column.field.substring(33);
        }
      }
      else if (isComments) {
        column.headerName = column.headerName + ` \u2013 ${t(`reporting.columns.${subtitle}.${extra}`)} ${t(`reporting.columns.diag_common.comments`)}`;
      }
      else if (isMobileOthersData) {
        column.headerName = column.headerName + ` \u2013 (${t(`reporting.columns.other_mobiles_others.sub_title`)}) \u2013 ` + extra;
      }
      else
        column.headerName = column.headerName + ` \u2013 ` + extra;
    }
  }

  let allChecked = true;
  let noneChecked = true;

  allAvailableColId.map(colId => {
    if (isColumnChecked(colId))
      noneChecked = false;
    else
      allChecked = false;
  });


  const toggleAllAvailableColumns = (toCheck) => {
    if (toCheck === false) {
      setNextColumns([]);
    }

    if (toCheck === true) {

      const newColumns = [];
      for (const colId of allAvailableColId) {
        const headerName = "";
        const tmpColumn = {
          width: 250,
          print: false,
          field: colId,
          customHeaderName: false,
          parentTitle: null,
          headerName: headerName
        }
        setColumnHeader(tmpColumn);
        newColumns.push(tmpColumn);
      }
      setNextColumns(newColumns);
    }
  };


  if (editingDiskHealthPercentageComputingRules) {
    return (
      <EditDiskHealthRules
        groupId={groupId}
        setEditingDiskHealthPercentageComputingRules={setEditingDiskHealthPercentageComputingRules}
      />
    )
  }
  else {
  return (
    <Prompt animated>
        <form className="prompt__container animated" style={{ height: '75%' }} onSubmit={e => handleUpdateColumns(e, nextColumns, /*reportingColumns,*/ scenario, module, settings)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('reporting.columns.settings.title')}</h1>
          </div>

          <div className="prompt__content" style={{ justifyContent: 'flex-start' }}>
              <Category
                title={t('reporting.columns.settings.order') + ' (' + nextColumns.length + ')'}
                isOpen isReOrganizeMenu
              >
              <div className="category__columns">
                  {nextColumns && nextColumns.length > 0 ? (
                  <Container
                    lockAxis="y"
                    onDrop={handleDragColumn}
                    dragHandleSelector=".drag-handle"
                  >
                      {nextColumns.map(column => {
                      // console.log("column=", column);
                      return (
                        <>
                          {column && column.field === "diag_common_$$_tests_comments" ? (
                            <>
                            </>
                          ) : (
                              <ActiveColumn
                                key={column.field}
                                column={column}
                                renaming={renaming}
                                setRenaming={setRenaming}
                                nextColumns={nextColumns}
                                setNextColumns={setNextColumns}
                                groupId={groupId}
                                setEditingDiskHealthPercentageComputingRules={setEditingDiskHealthPercentageComputingRules}
                              />
                            )}
                        </>
                      )
                    })}
                  </Container>

                ) : (
                  <h3 style={{ margin: '20px', textAlign: 'center' }}>
                    {t('reporting.columns.settings.no_selected')}
                  </h3>
                )}
              </div>
            </Category>

            <hr />

              <div className="prompt__content" style={{ justifyContent: 'flex-start' }}>
                <div className="subcategory__title" /*onClick={() => console.log("213...")}*/>
                  <h2>{t('reporting.columns.settings.all_availabe_columns')}</h2>

                  <div>
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleAllAvailableColumns(!allChecked)
                      }}>
                      <Switch
                        size="small"
                        checked={allChecked}
                        onChange={() => console.log("649...")}
                        offHandleColor="#888" onHandleColor="#080"
                        checkedHandleIcon={icon}
                        uncheckedHandleIcon={icon}
                      />
                    </span>

                  </div>
                </div>

              </div>

            {scenario && scenario.devicesType === devicesTypeValues.PCs && (
              <div className="prompt__content" style={{ justifyContent: 'flex-start' }}>
                  <SubCategory
                    // title={t('general')}
                    title={'general'}
                    columns={globalColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <Category
                    title={t('reporting.columns.settings.hardware')}
                    subCategories={Object.entries(allReportingColumns).filter(key => hardwareColumns.includes(key[0])).map(([title, columns]) => [title, columns])}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  >
              <div className="category__columns">
                {Object.entries(allReportingColumns).filter(key => hardwareColumns.includes(key[0])).map(([title, columns]) => (

                        <SubCategory
                          key={title}
                          columns={columns}
                          title={title}
                          parentTitle={'reporting.columns.settings.hardware'}
                          nextColumns={nextColumns}
                          setNextColumns={setNextColumns}
                          sdsExtraDiskHealthFlag={sdsExtraDiskHealthFlag}
                          sdsExtraDiskPerfFlag={sdsExtraDiskPerfFlag}
                        />
                ))}
              </div>
            </Category>

                  <SubCategory
                    title="device_wipe"
                    columns={deviceWipeColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="disk_wipe"
                    columns={diskWipeColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="imaging"
                    columns={imagingColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="deployments"
                    columns={deploymentColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="sbar"
                    columns={sbarColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <Category
                    title={t('reporting.columns.settings.diagnostics')}
                    subCategories={Object.entries(allDiagnosticColumns).filter(key => testsHardwareColumns.includes(key[0])).map(([title, columns]) => [title, columns])}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  >
              <div className="category__columns">
                {Object.entries(allDiagnosticColumns).filter(key => testsHardwareColumns.includes(key[0])).map(([title, columns]) => (
                        <SubCategory
                          key={title}
                          columns={columns}
                          title={title}
                          parentTitle={'reporting.columns.settings.diagnostics'}
                          nextColumns={nextColumns}
                          setNextColumns={setNextColumns}
                        />
                ))}
              </div>
            </Category>

                  <SubCategory
                    title="trade_in"
                    columns={tradeInColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                {/* <SubCategory title="manual_input" columns={manualInputsColumns} sdsQuestions={sdsQuestions} /> */}

                  <Category
                    title={t('reporting.columns.manual_input.sub_title')}
                    subCategories={Object.entries(allManualInputsColumns).filter(key => manualInputsColumns.includes(key[0])).map(([title, columns]) => [title, columns])}
                    sdsQuestions={sdsQuestions}
                    welcomeScreenManualInputs={welcomeScreenManualInputs}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  >
                  <div className="category__columns">
                      {Object.entries(allManualInputsColumns).filter(key => manualInputsColumns.includes(key[0])).map(([title, columns]) => (
                        <SubCategory
                          key={title}
                          columns={columns}
                          title={title}
                          parentTitle={'reporting.columns.manual_input.sub_title'}
                        sdsQuestions={sdsQuestions}
                          welcomeScreenManualInputs={welcomeScreenManualInputs}
                          nextColumns={nextColumns}
                          setNextColumns={setNextColumns}
                        />
                    ))}
                  </div>
                </Category>

                  <SubCategory
                    title="script"
                    columns={scriptsColumns}
                    scriptHeaders={scriptHeaders}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="bootimage"
                    columns={bootImageColumns}
                    scriptHeaders={scriptHeaders}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />
                
                  <SubCategory
                    title="hexadecimal_viewer"
                    columns={hexadecimalViewerColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="locks"
                    columns={locksColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

              </div>
            )}


            {scenario && scenario.devicesType === devicesTypeValues.mobiles && (
              <div className="prompt__content" style={{ justifyContent: 'flex-start' }}>
                  <SubCategory
                    // title={t('general_mobiles')}
                    title={'general_mobiles'}
                    columns={globalColumnsMobiles}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <Category
                    title={t('reporting.columns.settings.hardware_mobiles')}
                    subCategories={Object.entries(subHardwareColumnsMobiles).filter(key => hardwareColumnsMobiles.includes(key[0])).map(([title, columns]) => [title, columns])}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  >
                  <div className="category__columns">
                    {Object.entries(subHardwareColumnsMobiles).filter(key => hardwareColumnsMobiles.includes(key[0])).map(([title, columns]) => (
                        <SubCategory
                          key={title}
                          columns={columns}
                          title={title}
                          parentTitle={'reporting.columns.settings.hardware_mobiles'}
                          nextColumns={nextColumns}
                          setNextColumns={setNextColumns}
                        />
                    ))}
                  </div>
                </Category>

                  <SubCategory
                    title="tests_mobiles"
                    columns={testsColumnsMobiles}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="locks_mobiles"
                    columns={locksColumnsMobiles}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="operations_mobiles"
                    columns={operationsColumnsMobiles}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="manual_inputs_mobiles"
                    columns={manualInputsColumnsMobiles}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />

                  <SubCategory
                    title="other_mobiles"
                    columns={otherColumnsMobiles}
                    mobileOthersData={mobileOthersData}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />
              </div>
            )}


              {/* --- DISK --- */}
            {scenario && scenario.devicesType === devicesTypeValues.disks && (
              <div className="prompt__content" style={{ justifyContent: 'flex-start' }}>
                  <SubCategory
                    // title={t('disks_wipe')}
                    title={'disks_wipe'}
                    columns={disksWipeColumns}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  />
                
                  <Category
                    title={t('reporting.columns.manual_input.sub_title')}
                    subCategories={Object.entries(allManualInputsColumns).filter(key => manualInputsColumns.includes(key[0])).map(([title, columns]) => [title, columns])}
                    welcomeScreenManualInputs={welcomeScreenManualInputs}
                    nextColumns={nextColumns}
                    setNextColumns={setNextColumns}
                  >
                  <div className="category__columns">
                      {Object.entries(allManualInputsColumns).filter(key => manualInputsColumns.includes(key[0])).map(([title, columns]) => (
                        <SubCategory
                          key={title}
                          columns={columns}
                          title={title}
                          parentTitle={'reporting.columns.manual_input.sub_title'}
                          welcomeScreenManualInputs={welcomeScreenManualInputs}
                          nextColumns={nextColumns}
                          setNextColumns={setNextColumns}
                        />
                    ))}
                  </div>
                </Category>

              </div>
            )}
          </div>
        </PromptWrapper>

          {isEqual(previousColumns.current, nextColumns) ? (
          <PromptActions column>
            <Button className="btnSecondary" onClick={() => setShowColumnsMenu(false)}>{t('global.close')}</Button>
          </PromptActions>
        ) : (
          <PromptActions>
            <Button className="btnSecondary" onClick={handleResetColumns}>
              {t('global.cancel_changes')}
            </Button>

            <Button className="btnPrimary" type="submit">
              {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.save')}
            </Button>
          </PromptActions>
        )}
      </form>
    </Prompt>
  );
}
}
